import React, { useMemo } from "react";
import { GeneralNotification } from "../../pages";
import { GeneralNotificationController } from "../../controllers";
import { generalNotificationStore } from "../../stores";

const GeneralNotificationContainer = ({ closeModal }) => {

    const handleReadAll = async () => {
        await GeneralNotificationController.readAllNotifications();
    }

    const handleReadOne = async (payload) => {
        await GeneralNotificationController.readOneNotification(payload);
    }

    const currentTime = new Date();

    const getTimeDifference = (date) => {
        const timeDifference = currentTime.getTime() - new Date(date).getTime();
        const seconds = Math.floor(timeDifference / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);

        if (seconds < 60) {
            return `${seconds} second(s) ago`;
        } else if (minutes < 60) {
            return `${minutes} minute(s) ago`;
        } else if (hours < 24) {
            return `${hours} hour(s) ago`;
        } else if (days < 7) {
            return `${days} day(s) ago`;
        } else if (months < 1) {
            return `${weeks} week(s) ago`;
        } else if (years < 1) {
            return `${months} month(s) ago`;
        } else {
            return `${years} year(s) ago`;
        }
    }



    const notifications = useMemo(() => {
        const newNotifications = generalNotificationStore.notifications.notifications.map((item) => {
            return { ...item, timeAgo: getTimeDifference(item.createdAt) };
        })

        return newNotifications;
    }, [generalNotificationStore])




    return (
        <GeneralNotification
            handleReadOne={handleReadOne}
            handleReadAll={handleReadAll}
            closeModal={closeModal}
            notifications={notifications}
        />
    )
}
export default GeneralNotificationContainer;

